import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '../../store';

// Define types for the menu actions
type GetVariantsParams  = {
  productId: string;
}

// Async thunk for fetching variants
export const getVariants = createAsyncThunk<
  any, // Return type
  GetVariantsParams, // Params type
  {
    dispatch: AppDispatch;
    state: RootState;
  }
>(
  'menu/getVariants',
  async ({ productId }, { dispatch, getState }) => {
    try {
      // Get the access token from localStorage
      const accessToken = localStorage.getItem('accessToken');
      
      // Make an API call to fetch variants using the new ProductDefinitionByID query
      const response = await fetch('/api/products/variants', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          // Add authorization header if token exists
          ...(accessToken ? { 'Authorization': `Bearer ${accessToken}` } : {})
        },
        body: JSON.stringify({ productId }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch variants');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching variants:', error);
      throw error;
    }
  }
);
